<template>
  <div class="commonDiseaseBottomCard-container">
    <div class="tips">
      如果宝宝有以下严重症状，建议去医院确诊；如果没有，点击下一步。
    </div>
    <column
      v-for="(item, index) in list"
      :key="index"
      :name="item.name"
      :list="item.data"
    ></column>
    <div class="tips" style=";margin-top:20px">
      所有内容仅供参考，不可替代医师处方。
    </div>
  </div>
</template>
<script>
import column from './column';

export default {
  components: {
    column
  },
  data() {
    return {
      list: []
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$http
        .post(this.$url.severitySymptomList)
        .then(res => {
          this.list = res;
        })
        .catch(this.$catch);
    }
  }
};
</script>
<style lang="scss" scoped>
.commonDiseaseBottomCard-container {
  background-color: #fff;
  box-sizing: border-box;
  padding: 10px;
  font-size: 16px;
  .tips {
    font-size: 16px;
    color: #ffb03e;
    margin-bottom: 10px;
    padding-left: 20px;
    font-weight: 700;
  }
}
</style>
